import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import TableComponent from '../Table/Table';
import axios from 'axios';
import { useSelector } from 'react-redux';

function UserList() {

  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id', // accessor is the "key" in the data
      },
      {
        Header: 'Username',
        accessor: 'username', // accessor is the "key" in the data
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Active',
        accessor: 'active',
      },

    ],
    []
  );
  const [userFilter, setUserFilter] = useState({
    username: ""
  })
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [usersPages, setUsersPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const getListUsers = async () => {
    setLoading(true)
    const response = await axios.post(window.__CFG.API + "manager/ListUsers?page=" + currentPage, userFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setUsers(response.data.Result)
      setUsersPages(response.data.Pages)
    }
    setLoading(false)

  }
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "set_edit_user")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  useEffect(() => { getListUsers() }, [currentPage, userFilter])
  return (
    <Container>
      <Row >

        <Col>

          <Row className="justify-content-between mt-4" style={{ paddingBottom: 50 }}>
            <Col lg={4} md={4} sm={4}>

              <Col lg={3} md={4} sm={4}>
                <div className='add-affiliate-searchInput'>
                  <div style={{ position: "absolute" }} className="search-container">
                    <Form.Control style={{ padding: 2, minWidth: 190 }} type="text" className="search-input" placeholder="Search" onChange={(e) => { setUserFilter({ ...userFilter, username: e.target.value }) }} />
                    <i class="fa-solid fa-magnifying-glass" style={{ position: "absolute", right: 10, top: 8 }}></i>
                  </div>
                </div>
              </Col>
            </Col>

          </Row>


          <Row className="mt-0 mb-0">
            <div className="aff-dash-summary-table">

              <TableComponent columns={columns} data={users} actions={true} currentPage={currentPage} Pages={usersPages} onPageChange={handlePageChange} loading={loading} ActionLink={(row) => `/affiliate/settings/users/details?id=` + row.id} navigationColumn={affliatePermission ? "id" : ""} />
            </div>
          </Row>

        </Col>
      </Row>


    </Container>
  )
}

export default UserList